import { createContext, useContext, useState } from 'react';
import { Config } from '../types/configurations';

// datatype of the context provider declared here
interface IConfigContext {
  config: Config | null;
  setConfig: React.Dispatch<React.SetStateAction<Config | null>>;
  showDetailsModal: boolean;
  setShowDetailsModal: React.Dispatch<React.SetStateAction<boolean>>;
}

// creating the context here
const ConfigContext = createContext<IConfigContext | null>(null);

const ConfigProvider = ({ children }: { children: React.ReactNode }) => {
  // integration of react hooks here
  const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);
  const [config, setConfig] = useState<Config | null>(null);

  // rendering the context provider here
  return (
    <ConfigContext.Provider
      value={{ config, setConfig, showDetailsModal, setShowDetailsModal }}
    >
      {children}
    </ConfigContext.Provider>
  );
};

export default ConfigProvider;

// custom hook to access config context declared here
export const useConfigContext = () => {
  const context = useContext(ConfigContext);

  if (!context) {
    throw new Error('useConfigContext must be within ConfigProvider!');
  }

  return context;
};
